import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, authHeader } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("mg_token"));
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async (t) => {
    try {
      const { data } = await api.get("/auth/me", { headers: authHeader(t || token) });
      setUser(data);
    } catch {
      setUser(false);
      localStorage.removeItem("mg_token");
      setToken(null);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (token) fetchMe(token);
    else setLoading(false);
  }, []); // eslint-disable-line

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mg_token", data.token);
    setToken(data.token);
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("mg_token", data.token);
    setToken(data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("mg_token");
    setToken(null);
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, token, loading, login, register, logout, refresh: () => fetchMe(token) }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
